module.exports = __webpack_public_path__ + "img/51626525_L.6c73b8fb.png";